import axios from 'axios'
import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import logo from '../../assets/img/logo-w.png'
import { constants } from '../../Constants'
import { useNotificationsContext } from '../../context/NotificationsContext'
import { ModalLogin } from '../Modals/ModalLogin'
import { Avatar } from '../ui'
import { useToast } from '../ui/Toast/Toast'
import './HeaderNew.scss'

export const HeaderNew = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [isModalOpenLogin, setIsModalOpenLogin] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingForgotPassword, setLoadingForgotPassword] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const toast = useToast()

  const { unreadCount } = useNotificationsContext()

  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user')
    return stored ? JSON.parse(stored) : null
  })

  useEffect(() => {
    const stored = localStorage.getItem('user')
    if (stored) setUser(JSON.parse(stored))
  }, [location])

  useEffect(() => {
    setMenuOpen(false)
  }, [location.pathname])

  const loginUser = async (email, password) => {
    setLoading(true)
    try {
      const response = await axios.post(`${constants.urlLocal}login`, {
        email,
        password,
      })
      if (response.data.ok) {
        setUser(response.data.user)
        localStorage.setItem('user', JSON.stringify(response.data.user))
        localStorage.setItem('token', response.data.token)
        setIsModalOpenLogin(false)
        navigate('/')
        toast({ title: 'Sesión iniciada correctamente', status: 'success' })
      }
    } catch (error) {
      toast({
        title: 'Error al iniciar sesión',
        description: error.response?.data?.message || 'Revisa tus datos',
        status: 'error',
      })
    }
    setLoading(false)
  }

  const forgotPassword = async (email, phone) => {
    setLoadingForgotPassword(true)
    try {
      const response = await axios.post(`${constants.urlLocal}forgotPassword`, {
        email,
        phone,
      })
      if (response.data.ok) {
        toast({
          title: 'Correo enviado',
          description: 'Revisa tu correo para restablecer la contraseña',
          status: 'success',
        })
      }
    } catch (error) {
      toast({
        title: 'Error',
        description:
          error.response?.data?.message || 'Error al enviar el correo',
        status: 'error',
      })
    }
    setLoadingForgotPassword(false)
  }

  const logoutUser = () => {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    setUser(null)
    setMenuOpen(false)
    toast({ title: 'Sesión cerrada', status: 'info' })
    navigate('/login')
  }

  const isActive = path => location.pathname === path

  // Alias corto para el badge del menú mobile
  const bellBadge = unreadCount > 0 ? unreadCount : null

  return (
    <>
      <header className="tb-header">
        <div className="tb-header__inner">
          <Link to="/" className="tb-header__logo">
            <img src={logo} alt="Training Book" />
          </Link>

          <nav className="tb-header__nav tb-header__nav--desktop">
            <Link
              to="/"
              className={`tb-header__link ${isActive('/') ? 'tb-header__link--active' : ''}`}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              Clases
            </Link>
            {user && (
              <Link
                to="/my-inscriptions"
                className={`tb-header__link ${isActive('/my-inscriptions') ? 'tb-header__link--active' : ''}`}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                Mis clases
              </Link>
            )}
            {user && (
              <Link
                to="/my-calendar"
                className={`tb-header__link ${isActive('/my-calendar') ? 'tb-header__link--active' : ''}`}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                  <line x1="8" y1="14" x2="8" y2="14" />
                  <line x1="12" y1="14" x2="12" y2="14" />
                  <line x1="16" y1="14" x2="16" y2="14" />
                </svg>
                Calendario
              </Link>
            )}
            {user && (
              <Link
                to="/user-statistics"
                className={`tb-header__link ${isActive('/user-statistics') ? 'tb-header__link--active' : ''}`}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="20" x2="18" y2="10" />
                  <line x1="12" y1="20" x2="12" y2="4" />
                  <line x1="6" y1="20" x2="6" y2="14" />
                </svg>
                Estadísticas
              </Link>
            )}
            {user?.role === 'admin' && (
              <Link
                to="/dashboard"
                className={`tb-header__link ${isActive('/dashboard') ? 'tb-header__link--active' : ''}`}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="7" height="7" />
                  <rect x="14" y="3" width="7" height="7" />
                  <rect x="14" y="14" width="7" height="7" />
                  <rect x="3" y="14" width="7" height="7" />
                </svg>
                Panel
              </Link>
            )}
          </nav>

          <div className="tb-header__actions">
            {user && (
              <Link
                to="/notifications"
                className={`tb-header__bell ${location.pathname === '/notifications' ? 'tb-header__bell--active' : ''}`}
                aria-label="Notificaciones"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
                {unreadCount > 0 && (
                  <span className="tb-header__bell-badge">
                    {unreadCount > 9 ? '9+' : unreadCount}
                  </span>
                )}
              </Link>
            )}
            {user ? (
              <Link to="/profile" className="tb-header__user">
                <Avatar
                  name={`${user.name} ${user.lastname}`}
                  src={user.avatar}
                  size="sm"
                />
                <span className="tb-header__username">{user.name}</span>
              </Link>
            ) : (
              <button
                className="tb-header__login-btn"
                onClick={() => setIsModalOpenLogin(true)}
              >
                Iniciar sesión
              </button>
            )}
            <button
              className={`tb-header__hamburger ${menuOpen ? 'tb-header__hamburger--open' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menú"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`tb-mobile-menu ${menuOpen ? 'tb-mobile-menu--open' : ''}`}
      >
        <div
          className="tb-mobile-menu__overlay"
          onClick={() => setMenuOpen(false)}
        />
        <div className="tb-mobile-menu__panel">
          {user && (
            <Link
              to="/profile"
              className="tb-mobile-menu__user"
              onClick={() => setMenuOpen(false)}
            >
              <Avatar
                name={`${user.name} ${user.lastname}`}
                src={user.avatar}
                size="lg"
              />
              <div className="tb-mobile-menu__user-info">
                <p className="tb-mobile-menu__name">
                  <span className="tb-mobile-menu__name-highlight">
                    {user.name} {user.lastname}
                  </span>
                </p>
                <p className="tb-mobile-menu__role">
                  {user.role === 'admin' ? 'Administrador' : 'Deportista'}
                </p>
              </div>
              <svg
                className="tb-mobile-menu__user-arrow"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </Link>
          )}
          <nav className="tb-mobile-menu__nav">
            <Link
              to="/"
              className={`tb-mobile-menu__link ${isActive('/') ? 'tb-mobile-menu__link--active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              Calendario
            </Link>

            {user && (
              <Link
                to="/table-of-trophy"
                className={`tb-mobile-menu__link ${isActive('/table-of-trophy') ? 'tb-mobile-menu__link--active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
                  <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
                  <path d="M4 22h16" />
                  <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
                  <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
                  <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
                </svg>
                Ranking
              </Link>
            )}

            {user && (
              <Link
                to="/my-calendar"
                className={`tb-mobile-menu__link ${isActive('/my-calendar') ? 'tb-mobile-menu__link--active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                Mi Calendario
              </Link>
            )}

            <Link
              to="/classes-calendar"
              className={`tb-mobile-menu__link ${isActive('/classes-calendar') ? 'tb-mobile-menu__link--active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <line x1="8" y1="14" x2="16" y2="14" />
                <line x1="8" y1="18" x2="13" y2="18" />
              </svg>
              Horario de Clases
            </Link>

            {user && (
              <Link
                to="/notifications"
                className={`tb-mobile-menu__link ${isActive('/notifications') ? 'tb-mobile-menu__link--active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                <span className="tb-mobile-menu__notif-icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                  </svg>
                  {bellBadge && (
                    <span className="tb-mobile-menu__notif-badge">
                      {bellBadge > 9 ? '9+' : bellBadge}
                    </span>
                  )}
                </span>
                Notificaciones
                {bellBadge && (
                  <span className="tb-mobile-menu__notif-count">
                    {bellBadge}
                  </span>
                )}
              </Link>
            )}

            {user?.role === 'admin' && (
              <Link
                to="/dashboard"
                className={`tb-mobile-menu__link ${isActive('/dashboard') ? 'tb-mobile-menu__link--active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="7" height="7" />
                  <rect x="14" y="3" width="7" height="7" />
                  <rect x="14" y="14" width="7" height="7" />
                  <rect x="3" y="14" width="7" height="7" />
                </svg>
                Panel de control
              </Link>
            )}
          </nav>

          <div className="tb-mobile-menu__footer">
            {user ? (
              <button className="tb-mobile-menu__logout" onClick={logoutUser}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Cerrar sesión
              </button>
            ) : (
              <button
                className="tb-mobile-menu__logout"
                onClick={() => {
                  setMenuOpen(false)
                  setIsModalOpenLogin(true)
                }}
              >
                Iniciar sesión
              </button>
            )}
            <p className="tb-mobile-menu__credits">
              © {new Date().getFullYear()} Funcional Brothers ·{' '}
              <a
                href="https://aleburgos.es"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ale Burgos
              </a>
            </p>
          </div>
        </div>
      </div>

      <ModalLogin
        open={isModalOpenLogin}
        close={() => setIsModalOpenLogin(false)}
        login={loginUser}
        forgotPassword={forgotPassword}
        loading={loading}
        loadingForgotPassword={loadingForgotPassword}
      />
    </>
  )
}
